export enum EMergeType {
  N1 = 'n1',
  MLSN = 'mlsn',
}
